<template>
  <div id="page-user-list">
    <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      <div
        class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
        v-if="!readOnly"
        @click="$router.push('/broker/person-add')"
      >
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Add New</span>
      </div>
    </div>
    <div class="vx-card p-6" style="position: relative;">
      <transition name="fade">
        <div v-if="isRestoringFilters" class="filter-loading-overlay" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.5); z-index: 10; display: flex; align-items: center; justify-content: center; border-radius: 8px; pointer-events: none;">
          <div style="display: flex; align-items: center; gap: 8px; color: #7367f0; opacity: 0.8;">
            <div class="spinner" style="width: 16px; height: 16px; border: 2px solid rgba(115, 103, 240, 0.2); border-top-color: #7367f0; border-radius: 50%; animation: spin 0.6s linear infinite;"></div>
            <span style="font-size: 12px; font-weight: 500;">Restoring filters...</span>
          </div>
        </div>
      </transition>
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <vs-button v-if="displayExport != false" class="mb-4 md:mb-0 mr-2" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
        <div v-if="hasActiveFilters" class="flex items-center mr-2 mb-4 md:mb-0">
          <span class="text-sm font-medium" style="color: #7367f0;">
            <feather-icon icon="Filter" svgClasses="h-4 w-4 inline mr-1" />
            Filters active
          </span>
        </div>
        <vs-button type="border" color="primary" class="mb-4 md:mb-0" @click="clearAllFilters" icon-pack="feather" icon="icon-x">
          Clear Filters
        </vs-button>
      </div>
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>
      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import modulePersonList from "@/store/people/modulePersonList.js";
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import { isReadOnlyUser } from "@/helpers/roleAccess.js";

export default {
  components: {
    AgGridVue,
    vSelect,
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      readOnly: isReadOnlyUser(), // compte en lecture seule (Broker Status) : actions masquées
      displayExport: false,
      searchQuery: "",
      gridApi: null,
      gridOptions: {},
      filterChangeCounter: 0, // Pour forcer la réactivité du computed hasActiveFilters
      suppressSizeToFit: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "Name",
          field: "name",
          filter: true,
          order: "ASC",
          width: 320,
          cellRendererFramework: "CellRendererLink",
        },
        {
          headerName: "Category",
          valueGetter: function (params) {


            let jt = null
            if (params.data.jobtitle) 
            {
              if (!params.data.isdatestopofcontractok && params.data.isdatestartofcontractok >=0)
              {
                jt = "Employee"
              }
              else if (!params.data.isdatestopofcontractok && params.data.isdatestartofcontractok < 0)
              {
                jt = "Future Employee"
              }
              else if (params.data.isdatestopofcontractok && params.data.isdatestartofcontractok < 0)
              {
                jt = "Future Employee"
              }
              else if (params.data.isdatestopofcontractok >= 0 && params.data.isdatestartofcontractok <= 0)
              {
                jt = "Employee"
              }
              else if (params.data.isdatestopofcontractok < 0 && params.data.isdatestartofcontractok > 0)
              {
                jt = "Ex-Employee"
              } 
              else jt = "Employee"
            } 
            if (params.data.isbroker)
            {
            if (jt && params.data.category) return jt+","+params.data.category+",Reseller/Broker";
            else if (jt && !params.data.category) return jt+",Reseller/Broker";
            else if (!jt && params.data.category) return params.data.category+",Reseller/Broker";
            else return "Broker";
            }
            else if (params.data.isreseller)
            {
            if (jt && params.data.category) return jt+","+params.data.category+",Reseller";
            else if (jt && !params.data.category) return jt+",Reseller";
            else if (!jt && params.data.category) return params.data.category+",Reseller";
            else return "Reseller";
            }
            else 
            {
            if (jt && params.data.category) return jt+","+params.data.category;
            else if (jt && !params.data.category) return jt;
            else if (!jt && params.data.category) return params.data.category;
            else return "not applicable";
            }
          },
          filter: true,
          width: 150,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          headerName: "Reliability",
          valueGetter: function (params) {
            if (params.data.reliability === 5) return "5/5";
            else if (params.data.reliability === 4) return "4/5"; 
            else if (params.data.reliability === 3) return "3/5";
            else if (params.data.reliability === 2) return "2/5";
            else if (params.data.reliability === 1) return "1/5";
            else if (params.data.reliability === 0) return "0/5";
            else return "not defined";
          },
          filter: true,
          width: 150,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          headerName: "Email",
          field: "email",
          filter: true,
          width: 220,
        },
        {
          headerName: "Phone",
          field: "phone",
          filter: true,
          width: 180,
        },
        {
          headerName: "Country",
          field: "country",
          filter: true,
          width: 120,
        },
        {
          headerName: "Language",
          field: "language",
          filter: true,
          width: 120,
        },
        {
          headerName: "Source",
          field: "source",
          filter: true,
          width: 150,
        },
        {
          headerName: "Last interaction",
          field: "last_interaction",
          filter: true,
          width: 130,
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 120,
          cellRendererFramework: "CellRendererActions",
        },
      ],
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  computed: {
    usersData() {
      return this.$store.state.peopleList.people;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 100;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    hasActiveFilters() {
      // Utiliser filterChangeCounter pour forcer la réactivité
      const _ = this.filterChangeCounter;
      if (!this.gridApi) return false;
      const filterModel = this.gridApi.getFilterModel();
      const hasColumnFilters = filterModel && Object.keys(filterModel).length > 0;
      const hasSearchFilter = this.searchQuery && this.searchQuery.trim() !== '';
      return hasColumnFilters || hasSearchFilter;
    },
  },
  methods: {
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all",
      };
      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
      // Forcer la mise à jour du computed
      this.filterChangeCounter++;
    },
    clearAllFilters() {
      // Réinitialiser tous les filtres
      if (this.gridApi) {
        this.gridApi.setFilterModel(null);
        this.gridApi.setQuickFilter('');
        this.searchQuery = '';
        this.gridApi.onFilterChanged();
        // Forcer la mise à jour du computed
        this.filterChangeCounter++;
      }
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    
    // Ajouter un listener pour les changements de filtres
    if (this.gridApi) {
      this.gridApi.addEventListener('filterChanged', () => {
        // Incrémenter le compteur pour forcer la réactivité du computed hasActiveFilters
        this.filterChangeCounter++;
      });
    }
  },
  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      }); 
      this.$router.push({ path: "/dashboard/analytics" });
    } 
    this.$vs.loading()
    if (localStorage.getItem('login-roles').toLowerCase().includes("admin")) {
      this.displayExport = true
    }
    if (!modulePersonList.isRegistered) {
      this.$store.registerModule("peopleList", modulePersonList);
      modulePersonList.isRegistered = true;
    }
    this.$store.dispatch("peopleList/fetchPeopleBroker")
    .then((response) => {
      this.$vs.loading.close() 
    })
    .catch((err) => {
      console.error(err);
    });
  },
};
</script>

<style scoped>
@keyframes spin {
  to { transform: rotate(360deg); }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
